import React, { ReactElement } from 'react'


function WorkspaceWindowInfo(props) {
  return (
      <div className={`${props.className} fade-in windowInfo`}>
        {props.text.map((textRow) => (
            <React.Fragment key={textRow}>
              {textRow}
              <br />
            </React.Fragment>
        ))}
        <style jsx="true">{`
          .windowInfo {
            color: white;
            position: absolute;
          }
        `}</style>
      </div>
  )
}

export default WorkspaceWindowInfo
